import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, skip, switchMap, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';

import * as HarnessActions from '@fc-store/actions/harness.actions';
import { HarnessApiService } from '@fc-core';

@Injectable()
export class HarnessEffects {
  searchHarness$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HarnessActions.searchHarness),
      switchMap(({ search, assigned = false, device }) => {
        const nextSearch$ = this.actions$.pipe(
          ofType(HarnessActions.searchHarness),
          skip(1),
        );

        return this.harnessApiService.search(search, assigned, device).pipe(
          takeUntil(nextSearch$),
          map((data) => HarnessActions.searchHarnessSuccess({ data })),
          catchError((error) =>
            of(HarnessActions.searchHarnessFailure({ error })),
          ),
        );
      }),
    ),
  );

  allHarness$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HarnessActions.getAllHarness),
      switchMap(() => {
        return this.harnessApiService.loadAll().pipe(
          map((data) => HarnessActions.getAllHarnessSuccess({ data })),
          catchError((error) =>
            of(HarnessActions.searchHarnessFailure({ error })),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private harnessApiService: HarnessApiService,
  ) {}
}
